import { useSelector } from 'react-redux';

import { FeatureFlag } from 'modules/common/drawers/featureFlagDrawer/const/featureFlags';
import type { FeatureFlagFormData } from 'modules/common/drawers/featureFlagDrawer/types';
import { assertIsFeatureFlagFormData } from 'modules/common/drawers/featureFlagDrawer/utils';

import { getFeatureFlags } from './selectors';

export const useFeatureFlagValue = <F extends FeatureFlag>(
  featureFlagKey: F,
): FeatureFlagFormData[F] => {
  const featureFlagValues = useSelector(getFeatureFlags);
  assertIsFeatureFlagFormData(featureFlagValues);
  return featureFlagValues[featureFlagKey];
};
